import { OrderPayablesToolPanel } from "../../OrderPayablesToolPanel";
import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverSettlementProcess extends Layout {
    buttonManageRecurring: Button;
    buttonProcess: Button;
    layoutOrderPayablesToolPanel: OrderPayablesToolPanel;
    panelTaskFilters: Panel;
    sourceOrderPayablesCache: DataSource;
    tableDriverSettlement: Table;
}
